import {createContext} from "react";

export const Web3Context= createContext({});
export const TwitterSignedIn = createContext({});